import React, { useEffect, useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { spapiAPI } from '../services/api';
import './ServerStatsPanel.css';

const getAvgTimeColor = (avg) => {
  if (avg === null || avg === undefined) return '#666';
  if (avg > 40) return '#d9534f';
  if (avg > 20) return '#f0ad4e';
  return '#28a745';
};

const ServerStatsPanel = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [collapsed, setCollapsed] = useState(false);

  const loadStats = async () => {
    try {
      const response = await spapiAPI.stats();
      setStats(response.data);
      setError('');
    } catch (err) {
      console.error('Failed to load server stats:', err);
      setError('Error fetching server stats');
    }
  };

  useEffect(() => {
    loadStats();
    const interval = setInterval(loadStats, 10000);
    return () => clearInterval(interval);
  }, []);

  if (collapsed) {
    return (
      <div className="server-stats-panel collapsed">
        <button
          className="stats-toggle-btn"
          onClick={() => setCollapsed(false)}
          title="Expand server stats"
        >
          <LeftOutlined />
        </button>
      </div>
    );
  }

  const avgTime = stats?.average_response_time;
  const averageDisplay = avgTime !== null && avgTime !== undefined ? `${avgTime.toFixed(0)}s` : 'N/A';
  const avgTimeColor = getAvgTimeColor(avgTime);

  return (
    <div className="server-stats-panel">
      <div className="panel-header">
        <h3>Server Stats</h3>
        <button
          className="stats-toggle-btn"
          onClick={() => setCollapsed(true)}
          title="Collapse server stats"
        >
          <RightOutlined />
        </button>
      </div>

      <div className="stats-content">
        {error ? (
          <div className="stats-error">{error}</div>
        ) : (
          <>
            <div className="stats-row">
              <span>Average Response Time</span>
              <strong style={{ color: avgTimeColor }}>{averageDisplay}</strong>
            </div>
            <div className="stats-row">
              <span>Failed Requests</span>
              <strong>{stats?.failed_requests ?? 0}</strong>
            </div>
            <div className="stats-row">
              <span>Timed Out Requests</span>
              <strong>{stats?.timed_out_requests ?? 0}</strong>
            </div>
            <div className="stats-row">
              <span>Unprocessed Requests</span>
              <strong>{stats?.unprocessed_requests ?? 0}</strong>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ServerStatsPanel;
